import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/all.css";
import "./assets/font/font.css";
import * as echarts from "echarts";
// import visibility from 'vue-visibility-change';

// Vue.use(visibility);
Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
